import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { useAuth } from '../../auth/core/Auth';
import axios from 'axios';

export const CannotRegister = () => {  
    const intl = useIntl();
    const { logout, currentUser, setCurrentUser } = useAuth();

  return (
    <div className="container">
            <div className='alert alert-danger'>{intl.formatMessage({ id: 'You can not register to the Ege University with your current status using EGEYÖS or TR-YÖS. If you think there is a mistake, please contact Student Affairs.' })}</div>

          <div className="row justify-content-end">
              <div className="col-xl-6 d-flex justify-content-end">
                  <Button variant='danger' onClick={logout}>
                      {intl.formatMessage({ id: 'Logout' })}
                  </Button>
              </div>
          </div>
    </div>
  );
};